import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../../locales/messages";
import { useFlyerItemInspector } from "../../useFlyerItemInspector";
import { FlyerItemMiniPreview } from "./FlyerItemMiniPreview";
import { ItemSummary, flyerItemToSummary } from "./useFlyerItemSummaries";

interface Props {
  partnerId: string;
  itemSummaries: Map<string, ItemSummary | "loading">;
  reqOptions: { headers: { Authorization: string } };
}

export function SwapPartnerPreview({
  partnerId,
  itemSummaries,
  reqOptions,
}: Props) {
  const { t } = useTranslation();
  const cached = itemSummaries.get(partnerId);
  const shouldFetch = !cached || cached === "loading";
  const { item, loading: fetching } = useFlyerItemInspector(
    shouldFetch ? partnerId : undefined,
    reqOptions,
  );

  const summary = useMemo((): ItemSummary | "loading" | undefined => {
    if (cached && cached !== "loading") return cached;
    if (fetching || cached === "loading") return "loading";
    if (item) return flyerItemToSummary(item);
    return undefined;
  }, [cached, fetching, item]);

  return (
    <FlyerItemMiniPreview
      summary={summary}
      label={t(messages.Review_Manual_Cr_Swap_With())}
    />
  );
}
